import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import appVersion from "../../version";
import CloudComponent from "../CloudComponent";
import Cloud from "../Cloud";
import Header from "./Header";
import LanguageSelector from "./LanguageSelector";

// import { LanguageContext } from "../LanguageContext";

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_AUTH_TOKEN;

const translations = {
  en: {
    loginTitle: "Login",
    loginDescription: "Please enter your phone number to receive a One-Time Password (OTP).",
    phonePlaceholder: "Enter the Phone Number",
    sendOtp: "Send OTP",
    errorPhoneRequired: "Phone number is required.",
    errorPhoneInvalid: "Please enter a valid 10-digit phone number.",
    selectLanguage: "Select Language:"
  },
  Hi: {
    loginTitle: "लॉगिन",
    loginDescription: "कृपया अपना फ़ोन नंबर दर्ज करें ताकि एक बार का पासवर्ड (OTP) प्राप्त किया जा सके।",
    phonePlaceholder: "फ़ोन नंबर दर्ज करें",
    sendOtp: "OTP भेजें",
    errorPhoneRequired: "फ़ोन नंबर आवश्यक है।",
    errorPhoneInvalid: "कृपया वैध 10-अंकीय फ़ोन नंबर दर्ज करें।",
    selectLanguage: "भाषा चुनें:"
  },
  Kn: {
    loginTitle: "ಲಾಗಿನ್",
    loginDescription: "ಒನ್‌ ಟೈಂ ಪಾಸ್ವರ್ಡ್‌ (OTP) ಅನ್ನು  ಪಡೆಯಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಮೊಬೈಲ್‌ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.",
    phonePlaceholder: "ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    sendOtp: "OTP ಕಳುಹಿಸಿ",
    errorPhoneRequired: "ಫೋನ್ ಸಂಖ್ಯೆ ಅಗತ್ಯವಿದೆ.",
    errorPhoneInvalid: "ದಯವಿಟ್ಟು ಸರಿಯಾದ 10 ಅಂಕಿ ಫೋನ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.",
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:"
  },
  tulu: {
    loginTitle: "ಲಾಗಿನ್",
    loginDescription: "OTP ಮಲ್ಪೊಕ್ಕ, ದಯವಿಟ್ಟು ನಿಂದು ಫೋನ್ ನಂಬರ್ದ್ ನಮೂದ್ ಮಾಡ್.",
    phonePlaceholder: "ಫೋನ್ ನಂಬರ್ದ್ ನಮೂದ್ ಮಾಡ್",
    sendOtp: "OTP ಕಳುಹಿಸ",
    errorPhoneRequired: "ಫೋನ್ ನಂಬರ್ದ್ ಅಗತ್ಯ.",
    errorPhoneInvalid: "ದಯವಿಟ್ಟು ಸರಿಯಾದ 10 ಅಂಕಿ ಫೋನ್ ನಂಬರ್ದ್ ನಮೂದ್ ಮಾಡ್.",
    selectLanguage: "ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ:"
  }
};

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const vist_id = Cookies.get("visitor_id");
      const selectedLang = Cookies.get('selectedLanguage') || 'en';
  const app_ver = appVersion.app_ver;
  const location = useLocation();
  const { number } = location.state || {};
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    const cookieLang = Cookies.get("selectedLanguage") || "en";
    setLanguage(cookieLang);
  }, []);
  useEffect(() => {
    if (number) {
      setPhoneNumber(number);
    }
  }, [number]);

  const handleSendOtp = async () => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneNumber) {
      setError(translations[selectedLang].errorPhoneRequired);
      return;
    }
    if (!phoneRegex.test(phoneNumber)) {
      setError(translations[selectedLang].errorPhoneInvalid);
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          mob: phoneNumber,
          visitor_token: vist_id,
          app_ver: app_ver,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });

      const data = await response.json();
      if (data?.resp?.error_code === "0") {
        sessionStorage.setItem("otp_id", data.resp.otp_id);
        setError("");
        navigate("/otp", { replace: true });
      } else {
        setError(data?.resp?.message);
      }
    } catch (error) {
      console.error("Error during OTP sending:", error);
    }
  };

  return (
    <div className="login-container">
      <Header />
      <LanguageSelector onLanguageChange={setLanguage} />
      <div className="container">
        <h1>{translations[selectedLang].loginTitle}</h1>
        <p>{translations[selectedLang].loginDescription}</p>
        <input
          type="text"
          className="phone_number_input"
          placeholder={translations[selectedLang].phonePlaceholder}
          value={phoneNumber}
          readOnly
          autoComplete="off"
          name="number"
          maxLength="10"
        />
        {error && <p className="error-message">{error}</p>}
        <button className="phone_number_btn" onClick={handleSendOtp}>
          {translations[selectedLang].sendOtp}
        </button>
      </div>

      <div style={{ position: "fixed", bottom: "0", left: "0", zIndex: "0" }}>
        <CloudComponent />
      </div>
      <div style={{ position: "fixed", bottom: "0", right: "0", zIndex: "0" }}>
        <Cloud />
      </div>
    </div>
  );
};

export default Login;
